import * as React from "react";
import {cx} from "emotion";

import "./step-1-search.scss";

import {cs} from "@Common/react/chain-services";

import {ConfirmCancel} from "../../common/confirm-cancel";
import {Header}        from "../../common/header/header";

import {SearchingSection} from "./searching-section/searching-section";
import {StreetsSection}   from "./streets-section/streets-section";

export const Step1Search = ({entityId, next}) => cs(
    ["searchingSection", ({searchResult}, next) => SearchingSection({entityId, next})],
    ["streetsSection", ({searchingSection}, next) => StreetsSection({
        searchedForm: searchingSection.searchedForm,
        next,
    })],

    ["confirmCancel", (_, next) => ConfirmCancel({next})],

    ({confirmCancel, streetsSection, searchingSection}) => next({
        onPassiveClose: streetsSection.hasData && confirmCancel,
        createRequestData: async () => ({
            searchForm: searchingSection.searchedForm,
            searchResult: {
                ...await streetsSection.createRequestData(),
            },
        }),
        getDefaultListName: () => searchingSection.searchedForm.address,

        render: ({onCancel, cancelLabel, onNext}) => cs(

            () => (
                <div className="step-1-search-7om">
                    {Header({
                        icon: require("../../../../mailing-icons/listtype-radius.png"),
                        title: "Build Radius List",
                        subTitle: "Build a list targeting prospects surrounding a specific point.",
                    })}

                    {searchingSection.render({
                        loadAddresses: streetsSection.loadAddresses,
                        onSearchResult: (result) => {
                            streetsSection.setSearchResult(result);
                        },
                    })}

                    {streetsSection.render({
                        searchedAddress: searchingSection.searchedForm?.address,
                    })}

                    {Footer({
                        cancelLabel,
                        onCancel,
                        nextAction: streetsSection.getNextAction({onNext}),
                    })}
                </div>
            ),
        ),
    })
);

const Footer = ({cancelLabel, onCancel, nextAction=undefined}) => cs(
    ["confirmCancel", (_, next) => ConfirmCancel({next})],
    ({confirmCancel}) => (
        <div className="footer">
            <button {...{
                className: "cancel",
                onClick: async () => {
                    if (await confirmCancel()) {
                        onCancel();
                    }
                },
                "xd-qa-type": "button",
                "xd-qa-name": "Build Radius List " + cancelLabel,
            }}>
                {cancelLabel}
            </button>

            {nextAction && (
                <button {...{
                    className: cx("next", {disabled: nextAction.disabled}),
                    onClick: nextAction.action,
                    "xd-qa-type": "button",
                    "xd-qa-name": "Build Radius List Next",
                }}>
                    Next
                </button>
            )}
        </div>
    ),
);

